import { useQueryClient } from '@tanstack/react-query';
import { getGetModulesQueryKey } from '../../common/api/endpoints/modules/modules';
import {
  useApproveModuleVersion,
  useRejectModuleVersion,
} from '../../common/api/endpoints/module-workflow/module-workflow';

/**
 * Hook that provides wrapper functions around module approval actions
 * for use in the admin panel
 */
export const useAdminModuleApproval = () => {
  const queryClient = useQueryClient();
  const approveVersionMutation = useApproveModuleVersion();
  const rejectVersionMutation = useRejectModuleVersion();

  const queryKey = getGetModulesQueryKey({ state: 'pending_approval' });

  // Approve a module version (transition from PENDING_APPROVAL to PUBLISHED)
  const approveModuleVersion = async (moduleId: string, version: string, comment = '') => approveVersionMutation.mutateAsync(
    {
      moduleId,
      version,
      data: { comment },
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey });
      },
    },
  );

  // Reject a module version (transition from PENDING_APPROVAL back to DRAFT)
  const rejectModuleVersion = async (moduleId: string, version: string, comment = '') => rejectVersionMutation.mutateAsync(
    {
      moduleId,
      version,
      data: { comment },
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey });
      },
    },
  );

  return {
    approveModuleVersion,
    rejectModuleVersion,
    isApproving: approveVersionMutation.isPending,
    isRejecting: rejectVersionMutation.isPending,
  };
};

export default useAdminModuleApproval;
